import { useEffect } from 'react'
import { useTranslation } from 'react-i18next'
import { useSelector } from 'react-redux'
import { getLanguage } from 'redux/reducers/users'

export default function useLanguage () {
  const language = useSelector(getLanguage)
  const { i18n } = useTranslation()

  useEffect(() => {
    const toggle = (lng: string) => i18n.changeLanguage(lng)
    if (language) {
      toggle(language)
    }
  }, [language, i18n])
}
